import PaginatedSearchDropdown from './PaginatedSearchDropdown';

export default PaginatedSearchDropdown;
